module.exports = __webpack_public_path__ + "static/media/AlumnicardSmllScreenBackGround.606a281d.svg";